// Content.js
import React from "react";
import OverView from "./innerContents/OverView";
import Itinerary from "./innerContents/Itinerary";
import TourInformation from "./innerContents/TourInformation";
import InclusionExclusion from "./innerContents/InclusionExclusion";
import CancellationPolicy from "./innerContents/CancellationPolicy";
import TourDates from "./innerContents/TourDates";
import TourDocuments from "./innerContents/TourDocuments";

const Content = ({ activeTab }) => {
  return (
    <div className="tab-content tab-content-main" id="myTabContent">
      {activeTab === "Overview" && <OverView />}
      {activeTab === "Itinerary" && <Itinerary />}
      {activeTab === "Tour Information" && <TourInformation />}
      {activeTab === "Inclusions / Exclusions" && <InclusionExclusion />}
      {activeTab === "Cancellation Policy" && <CancellationPolicy />}
      {activeTab === "TourDates" && <TourDates />}
      {activeTab === "Documents" && <TourDocuments />}
    </div>
  );
};

export default Content;
